import UdeskLocales from 'UdeskLocales';
import Udesk from 'Udesk';
import React from 'react';
import { Button, message, notification } from 'udesk-ui';
import { postAutoMateTasksCaseByTaskId } from 'src/api/autoMateTasks/case/{taskId}';
import { postInspectionRemarkModelConfigs } from 'src/api/inspectionRemarkModelConfigs';
import {
    getInspectionRemarkModelConfigsById,
    putInspectionRemarkModelConfigsById,
} from 'src/api/inspectionRemarkModelConfigs/{id}';
import {
    AppealConfigModeMap,
    SamplePeriodModeMap,
} from './components/business-config/const';
import { checkRequird } from 'Component/common/Frequency';
import { AgentTyoeMap } from 'Component/pages/components/massage-push-configuration/other-push/components/TicketConfig';
import { TriggerStrategyMap } from './components/AutoAssign';

const LimitType = {
    Upper: 1,
    Floor: 2,
};

export default class TasksAutomaticAddComponent extends React.Component {
    //#region privates
    privates = {
        testList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
        conditionList: [],
        conditionList_text: [],
        conditionList_voice: [],
        conditionList_ticket: [],
        conditionList_video: [],
        conditionList_survey: [],
        automaticArchiving: false,
        conditions: [],
        reviewOptions: [],
        spoktOptions: [],
        spoketOptionsExport: [],
        inspectionOptionsExport: [],
        reviewOptionsExport: [],
        appealOptionsExport: {
            complainInspectorHidden: 0,
            complainHighLightShow: 1,
        },
        appaelable: {
            enableComplainAiInspect: 1,
            enableComplainManualInspect: 1,
        },
        reviewOptionsList: [],
        spoktOptionsList: [],
        inspectionOptionsList: [],
        fastSampleInDetailList: [],
        permitComplainCount: 1,
        complainPeriod: 3,
        reviewAging: undefined,
        exportNumLimit: 10000,
        permitCustomReasonList: [],
        pushRules: [],
        assessRules: [],
        sampleAssign: {
            taskType: 2,
            assignModel: Udesk.enums.distributeTypes.average.id,
            assignConfList: [],
        },
        defaultSampleAssignConf: {
            assignType: 1,
            inspectorList: [],
        },
        reviewAssign: {
            taskType: 3,
            assignModel: Udesk.enums.distributeTypes.average.id,
            assignConfList: [],
        },
        reviewAssignSecondLevel: {
            taskType: 16,
            assignModel: Udesk.enums.distributeTypes.average.id,
            assignConfList: [],
            secondLevelRecheckScope: TriggerStrategyMap.Passing,
            enabledAutoSecondReview: 0,
        },
        defaultReviewAssignConf: {
            assignType: 1,
            inspectorList: [],
        },
        defaultReviewAssignConfSecondLevel: {
            assignType: 1,
            inspectorList: [],
        },
        isFilterVisible: false,
        // conditionJson: [],
        // conditionJsonInfo: [],
        // conditionJsonInfoMap: {},
        // judgeStrategyMap: {},
        //自动推送
        automaticPushConfigList: [],
        everyAgentCheckUpperLimit: {
            limitType: LimitType.Upper,
            status: 0,
            cycle: Udesk.enums.samplingFrequencyTypes.everyWeek.id,
            numLimit: 0,
            // 不知用途，但需要传给后台
            type: 0,
        },
        everyAgentCheckFloorLimit: {
            limitType: LimitType.Floor,
            status: 0,
            cycle: Udesk.enums.samplingFrequencyTypes.everyWeek.id,
            numLimit: 0,
            type: 0,
        },
        // activeKey: 'samplingTarget',
        activeKey: 'automaticAddition',
        assignShowType: 'sampleAssign',
        pushConfigTab: '',
        pushTypeRadioValue: Udesk.enums.messageType.filter((messageType) => messageType > 1)[0].id,
        //案例库同步
        caseConfigList: [],
        remarkModel: '',
        remarkModelId: null,
        samplingTargetRef: React.createRef(),
        // 详情显示配置
        callDetailShowConfigList: [],
        callDetailShowConfigOption: [
            {
                label: /* 显示静默时长 */ UdeskLocales['current'].pages.tasks.manage.template
                    .automaticAdd.component.displaySilentDuration,
                key: '1',
            },
            {
                label: /* 播放条显示情绪 */ UdeskLocales['current'].pages.tasks.manage.template
                    .automaticAdd.component.playbarDisplayMood,
                key: '2',
            },
            {
                label: /* 播放条显示智能标签 */ UdeskLocales['current'].pages.tasks.manage.template
                    .automaticAdd.component.playbarDisplaySmartLabel,
                key: '3',
            },
            {
                label: /* 播放条显示命中规则 */ UdeskLocales['current'].pages.tasks.manage.template
                    .automaticAdd.component.playbarDisplayHitRule,
                key: '4',
            },
        ],
        overSecondsDurationShow: 30, // 秒
        complainPeriodMode: AppealConfigModeMap.Validity,
        refreshComplainPeriodAndNum: 0,
        complainCycle: undefined,
        complainScope: undefined,
        complainDeadTime: undefined,
        reviewCycle: undefined,
        reviewScope: undefined,
        reviewDeadTime: undefined,
        complainDeadCount: undefined,
        finalReview: undefined,
        sdkShowCaseLibrary: undefined,
        samplePeriodMode: 0,
        sampleAging: undefined,
        sampleCycle: undefined,
        sampleScope: undefined,
        sampleDeadTime: undefined,
        // 成绩查看
        viewGradeConfig: undefined,
        viewGradeDataResConfigId: undefined,
    };
    //#endregion
    //#region actions
    actions = {
        onEdit(messageType, targetKey, action) {
            this.actions[action](messageType, targetKey);
        },
        add(messageType) {
            this.privates.automaticPushConfigList.push(
                createAutomaticPushConfig(messageType, this.privates.model.taskId)
            );
            // window.console.log('add', 101,this.privates.automaticPushConfigList)
            this.actions.update();
        },
        remove(messageType, targetKey) {
            // let {configuration} = item;
            let id = targetKey;
            let { automaticPushConfigList } = this.privates;
            this.privates.automaticPushConfigList = automaticPushConfigList.filter(
                (item) => item._id !== id
            );
            // window.console.log('remove', 101,this.privates.automaticPushConfigList)
            this.actions.update();
        },
        onPushConfigTabsChange(activeKey) {
            this.privates.pushConfigTab = activeKey;
            this.actions.update();
        },
        onPushTypeRadioChange(e) {
            this.privates.pushTypeRadioValue = e.target.value;

            this.actions.update();
        },
        changeActiveTab(activeKey) {
            this.privates.activeKey = activeKey;
            this.actions.update();
        },

        onViewGradeConfigChange(config) {
            this.privates.viewGradeConfig = config;
            this.actions.update();
        },

        saveViewGrade() {
            const { privates, props } = this;
            const viewGradeConfig = privates.viewGradeConfig;
            if (!viewGradeConfig) return;

            const taskId = privates.model.taskId;
            const inspectDataSource = privates.type;
            const taskStatus = viewGradeConfig.enabled !== false ? 1 : 0;
            const isRealtime = viewGradeConfig.pushTiming === 'realtime';
            const isAutoExecute = isRealtime
                ? Udesk.enums.autoAddTypes.realTimeAdd.id
                : Udesk.enums.autoAddTypes.timingAdd.id;

            const fieldList = privates.model.customFields || [];
            const rule = Array.isArray(viewGradeConfig.scheduledRules) && viewGradeConfig.scheduledRules[0];
            const conditionList = getQueryConditionList(
                fieldList,
                rule?.filter?.conditionList || []
            );
            const baseFilter = {
                languageType: 0,
                autoDetection: 0,
                multiLanguageTypeList: [],
                conditionList: conditionList || [],
                judgeStrategy: rule?.filter?.judgeStrategy ?? 1,
                customJudgeLogic: rule?.filter?.customJudgeLogic ?? '',
                additionalQueryList: [],
            };
            const strategy = rule?.strategy || {};
            const autoMateLoadConf = {
                version: 0,
                inspectDataSource: inspectDataSource,
                loadCycle: strategy.loadCycle ?? Udesk.enums.samplingFrequencyTypes.everyDay.id,
                loadScope: strategy.loadScope ?? (Udesk.enums.samplingEveryDayTimeTypes?.today?.id ?? 2),
                executeTime: strategy.executeTime || '09:00:00',
                dayOfWeek: strategy.dayOfWeek ?? 0,
                dayOfMonth: strategy.dayOfMonth ?? 0,
            };
            if (autoMateLoadConf.executeTime.length === 5) {
                autoMateLoadConf.executeTime = autoMateLoadConf.executeTime + ':00';
            }
            const payload = {
                id: privates.viewGradeDataResConfigId ?? 0,
                taskId: taskId,
                inspectDataSource: inspectDataSource,
                taskStatus: taskStatus,
                taskType: 17,
                isAutoExecute: isAutoExecute,
                baseFilter: baseFilter,
                autoMateLoadConf: autoMateLoadConf,
            };

            const url = Udesk.business.apiPath.concatApiPath(
                `/autoMateTasks/saveDataResConfig/${taskId}`,
                props.sdkOptions
            );
            Udesk.ajax.post(url, payload).then(
                (resp) => {
                    if (resp?.data?.id != null) {
                        this.privates.viewGradeDataResConfigId = resp.data.id;
                    }
                    Udesk.ui.notify.success(UdeskLocales.current.business.info.saveSuccess);
                },
                (reason) => {
                    Udesk.ui.notify.error(
                        reason?.errorMsg || UdeskLocales.current.business.info.saveError
                    );
                }
            );
        },
        onAppealValueChanged(checkedValues = []) {
            this.privates.appealOptionsExport = checkedValues.reduce(
                (prev, cur) => ({ ...prev, [cur]: 1 }),
                {
                    complainInspectorHidden: 0,
                    complainHighLightShow: 0,
                }
            );
            this.actions.update();
        },
        onAppealableChanged(checkedValues = []) {
            console.log(checkedValues);
            this.privates.appaelable = checkedValues.reduce(
                (prev, cur) => ({ ...prev, [cur]: 1 }),
                {
                    enableComplainAiInspect: 0,
                    enableComplainManualInspect: 0,
                }
            );
            this.actions.update();
        },
        callDetaiConfigChanged(checkedValues = []) {
            console.log(
                'callDetaiConfigChanged',
                checkedValues,
                this.privates.overSecondsDurationShow
            );
            this.privates.callDetailShowConfigList = checkedValues;
            this.actions.update();
        },
        onValueChanged(obj, key, e) {
            let value = e;
            if (e?.target) {
                value = e.target.value;
            }
            obj[key] = value;
            console.log('onValueChanged', key, value);
            this.actions.update();
        },

        operatorGatherChanged(val) {
            this.privates.conditionList = val;
        },

        changeStatus(type, inspectDataSource) {
            let params = {
                taskId: this.privates.model.taskId,
            };

            let status = this.privates.model.processStatus[type];

            if (inspectDataSource) {
                status = this.privates.model.processStatus[type]?.[inspectDataSource];
                params.inspectDataSource = inspectDataSource;
            }

            if (status) {
                params.taskStatus = 0;
            } else {
                params.taskStatus = 1;
            }

            if (
                type === Udesk.enums.autoMateTasks.autoLoad.id ||
                type === Udesk.enums.autoMateTasks.mixed_autoload.id
            ) {
                params.taskTypes = [6];
            } else if (type === Udesk.enums.autoMateTasks.sample.id) {
                params.taskTypes = [1];
            } else if (type === Udesk.enums.autoMateTasks.assign.id) {
                const isTicket = this.privates.type === Udesk.enums.inspectDataSources.ticket.id;
                // 工单的情况下，隐藏了复核分配
                if (isTicket) {
                    params.taskTypes = [2];
                } else {
                    params.taskTypes = [2, 3];
                }

                // } else if (type === Udesk.enums.autoMateTasks.pushes.id) {
                //     params.taskTypes = [4];
            } else if (type === Udesk.enums.autoMateTasks.monitor.id) {
                params.taskTypes = [8];
            } else if (type === Udesk.enums.autoMateTasks.check.id) {
                params.taskTypes = [5];
            } else if (type === Udesk.enums.autoMateTasks.assess.id) {
                params.taskTypes = [7];
            } else if (type === Udesk.enums.autoMateTasks.case.id) {
                params.taskTypes = [9];
            } else if (type === Udesk.enums.autoMateTasks.summary.id) {
                params.taskTypes = [13];
            } else if (type === Udesk.enums.autoMateTasks.topic_setting.id) {
                params.taskTypes = [15];
            }

            let url = Udesk.business.apiPath.concatApiPath(`/autoMateTasks`, this.props.sdkOptions);
            Udesk.ajax.put(url, params).then(
                (resp) => {
                    Udesk.ui.notify.success(
                        UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                            .updateStatusSuccess
                    );
                    this.privates.model.processStatus = resp.data;
                    this.actions.update();
                },
                (reason) => {
                    Udesk.ui.notify.error(
                        reason.errorMsg ||
                            UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                .updateStatusFailed
                    );
                }
            );
        },

        // 1、自动添加
        saveAutomaticAddition() {
            const { privates, props } = this;
            const automaticAdd = privates.model.automaticAdd;
            const fieldList = privates.model.customFields;
            const conditions = getQueryConditionList(fieldList, privates.conditionList);
            if (!this.privates.model.automaticAdd.isAutoExecute) {
                if (conditions == null || conditions.length === 0) {
                    return Udesk.ui.notify.error(
                        Udesk.utils.string.format(
                            UdeskLocales.current.business.info.cannotBeNull,
                            UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                .screeningCondition
                        )
                    );
                }

                if (
                    (automaticAdd && automaticAdd.baseFilter == null) ||
                    automaticAdd.baseFilter.judgeStrategy == null
                ) {
                    return Udesk.ui.notify.error(
                        Udesk.utils.string.format(
                            UdeskLocales.current.business.info.cannotBeNull,
                            UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                .conditionalRules
                        )
                    );
                }
            }
            let params = {
                ...automaticAdd,
                baseFilter: {
                    conditionList: conditions,
                    judgeStrategy: automaticAdd.baseFilter.judgeStrategy,
                    customJudgeLogic: automaticAdd.baseFilter.customJudgeLogic,
                },
                intelligentCondition: automaticAdd.intelligentCondition,
            };
            let url = Udesk.business.apiPath.concatApiPath(
                '/autoMateTasks/autoLoad-plus/' + privates.model.taskId,
                props.sdkOptions
            );
            Udesk.ajax.post(url, [params]).then(
                (resp) => {
                    Udesk.ui.notify.success(
                        this.props.route.name === 'informationCollectDataAddAuto'
                            ? `${UdeskLocales.current.components.pages.dataAdd.types.auto}${UdeskLocales.current.business.info.editSuccess}`
                            : `${UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index.name}${UdeskLocales.current.business.info.editSuccess}`
                    );
                },
                (reason) => {
                    Udesk.ui.notify.error(
                        reason.errorMsg ||
                            `${UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index.name}${UdeskLocales.current.business.info.editError}`
                    );
                }
            );
        },

        // 1、自动添加 - 混合类型
        saveAutomaticAdditionMixed() {
            const { privates, props } = this;
            const automaticAdd = privates.model.automaticAdd;
            const fieldList = privates.model.customFields;

            const conditions_text = getQueryConditionList(fieldList, privates.conditionList_text);
            if (
                privates.model.processStatus.MIXED_AUTOLOAD?.[
                    Udesk.enums.inspectDataSources.textDialogue.id
                ] === 1 &&
                !this.privates.model.automaticAdd.text.isAutoExecute
            ) {
                if (conditions_text == null || conditions_text.length === 0) {
                    return Udesk.ui.notify.error(
                        Udesk.utils.string.format(
                            UdeskLocales.current.business.info.cannotBeNull,
                            UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                .screeningCondition
                        )
                    );
                }

                if (
                    (automaticAdd && automaticAdd.text?.baseFilter == null) ||
                    automaticAdd.text?.baseFilter.judgeStrategy == null
                ) {
                    return Udesk.ui.notify.error(
                        Udesk.utils.string.format(
                            UdeskLocales.current.business.info.cannotBeNull,
                            UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                .conditionalRules
                        )
                    );
                }
            }

            let params_text = {
                ...automaticAdd.text,
                taskId: this.privates.model.taskId,
                taskType: 6,
                baseFilter: {
                    conditionList: conditions_text,
                    judgeStrategy: automaticAdd.text.baseFilter.judgeStrategy,
                    customJudgeLogic: automaticAdd.text.baseFilter.customJudgeLogic,
                },
                intelligentCondition: automaticAdd.text.intelligentCondition,
                inspectDataSource: Udesk.enums.inspectDataSources.textDialogue.id,
                taskStatus:
                    privates.model.processStatus.MIXED_AUTOLOAD?.[
                        Udesk.enums.inspectDataSources.textDialogue.id
                    ],
            };

            const conditions_voice = getQueryConditionList(fieldList, privates.conditionList_voice);
            if (
                privates.model.processStatus?.MIXED_AUTOLOAD?.[
                    Udesk.enums.inspectDataSources.voiceCall.id
                ] === 1 &&
                !this.privates.model.automaticAdd.voice.isAutoExecute
            ) {
                if (conditions_voice == null || conditions_voice.length === 0) {
                    return Udesk.ui.notify.error(
                        Udesk.utils.string.format(
                            UdeskLocales.current.business.info.cannotBeNull,
                            UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                .screeningCondition
                        )
                    );
                }

                if (
                    (automaticAdd && automaticAdd.voice?.baseFilter == null) ||
                    automaticAdd.voice?.baseFilter.judgeStrategy == null
                ) {
                    return Udesk.ui.notify.error(
                        Udesk.utils.string.format(
                            UdeskLocales.current.business.info.cannotBeNull,
                            UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                .conditionalRules
                        )
                    );
                }
            }

            let params_voice = {
                ...automaticAdd.voice,
                taskId: this.privates.model.taskId,
                taskType: 6,
                baseFilter: {
                    conditionList: conditions_voice,
                    judgeStrategy: automaticAdd.voice.baseFilter.judgeStrategy,
                    customJudgeLogic: automaticAdd.voice.baseFilter.customJudgeLogic,
                },
                intelligentCondition: automaticAdd.voice.intelligentCondition,
                inspectDataSource: Udesk.enums.inspectDataSources.voiceCall.id,
                taskStatus:
                    privates.model.processStatus.MIXED_AUTOLOAD?.[
                        Udesk.enums.inspectDataSources.voiceCall.id
                    ],
            };

            const conditions_ticket = getQueryConditionList(
                fieldList,
                privates.conditionList_ticket
            );
            if (
                privates.model.processStatus?.MIXED_AUTOLOAD?.[
                    Udesk.enums.inspectDataSources.ticket.id
                ] === 1 &&
                !this.privates.model.automaticAdd.ticket.isAutoExecute
            ) {
                if (conditions_ticket == null || conditions_ticket.length === 0) {
                    return Udesk.ui.notify.error(
                        Udesk.utils.string.format(
                            UdeskLocales.current.business.info.cannotBeNull,
                            UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                .screeningCondition
                        )
                    );
                }

                if (
                    (automaticAdd && automaticAdd.ticket?.baseFilter == null) ||
                    automaticAdd.ticket?.baseFilter.judgeStrategy == null
                ) {
                    return Udesk.ui.notify.error(
                        Udesk.utils.string.format(
                            UdeskLocales.current.business.info.cannotBeNull,
                            UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                .conditionalRules
                        )
                    );
                }
            }

            let params_ticket = {
                ...automaticAdd.ticket,
                taskId: this.privates.model.taskId,
                taskType: 6,
                baseFilter: {
                    conditionList: conditions_ticket,
                    judgeStrategy: automaticAdd.ticket.baseFilter.judgeStrategy,
                    customJudgeLogic: automaticAdd.ticket.baseFilter.customJudgeLogic,
                },
                intelligentCondition: automaticAdd.ticket.intelligentCondition,
                inspectDataSource: Udesk.enums.inspectDataSources.ticket.id,
                taskStatus:
                    privates.model.processStatus.MIXED_AUTOLOAD?.[
                        Udesk.enums.inspectDataSources.ticket.id
                    ],
            };

            let url = Udesk.business.apiPath.concatApiPath(
                '/autoMateTasks/autoLoad-plus/' + privates.model.taskId,
                props.sdkOptions
            );

            const conditions_video = getQueryConditionList(fieldList, privates.conditionList_video);
            if (
                privates.model.processStatus?.MIXED_AUTOLOAD?.[
                    Udesk.enums.inspectDataSources.videoCall.id
                ] === 1 &&
                !this.privates.model.automaticAdd.video.isAutoExecute
            ) {
                if (conditions_video == null || conditions_video.length === 0) {
                    return Udesk.ui.notify.error(
                        Udesk.utils.string.format(
                            UdeskLocales.current.business.info.cannotBeNull,
                            UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                .screeningCondition
                        )
                    );
                }

                if (
                    (automaticAdd && automaticAdd.video?.baseFilter == null) ||
                    automaticAdd.video?.baseFilter.judgeStrategy == null
                ) {
                    return Udesk.ui.notify.error(
                        Udesk.utils.string.format(
                            UdeskLocales.current.business.info.cannotBeNull,
                            UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                .conditionalRules
                        )
                    );
                }
            }

            let params_video = {
                ...automaticAdd.video,
                taskId: this.privates.model.taskId,
                taskType: 6,
                baseFilter: {
                    conditionList: conditions_video,
                    judgeStrategy: automaticAdd.video.baseFilter.judgeStrategy,
                    customJudgeLogic: automaticAdd.video.baseFilter.customJudgeLogic,
                },
                intelligentCondition: automaticAdd.video.intelligentCondition,
                inspectDataSource: Udesk.enums.inspectDataSources.videoCall.id,
                taskStatus:
                    privates.model.processStatus.MIXED_AUTOLOAD?.[
                        Udesk.enums.inspectDataSources.videoCall.id
                    ],
            };

            const conditions_survey = getQueryConditionList(
                fieldList,
                privates.conditionList_survey
            );
            if (
                privates.model.processStatus?.MIXED_AUTOLOAD?.[
                    Udesk.enums.inspectDataSources.survey.id
                ] === 1 &&
                !this.privates.model.automaticAdd.survey.isAutoExecute
            ) {
                if (conditions_survey == null || conditions_survey.length === 0) {
                    return Udesk.ui.notify.error(
                        Udesk.utils.string.format(
                            UdeskLocales.current.business.info.cannotBeNull,
                            UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                .screeningCondition
                        )
                    );
                }

                if (
                    (automaticAdd && automaticAdd.survey?.baseFilter == null) ||
                    automaticAdd.survey?.baseFilter.judgeStrategy == null
                ) {
                    return Udesk.ui.notify.error(
                        Udesk.utils.string.format(
                            UdeskLocales.current.business.info.cannotBeNull,
                            UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                                .conditionalRules
                        )
                    );
                }
            }

            let params_survey = {
                ...automaticAdd.survey,
                taskId: this.privates.model.taskId,
                taskType: 6,
                baseFilter: {
                    conditionList: conditions_survey,
                    judgeStrategy: automaticAdd.survey.baseFilter.judgeStrategy,
                    customJudgeLogic: automaticAdd.survey.baseFilter.customJudgeLogic,
                },
                intelligentCondition: automaticAdd.survey.intelligentCondition,
                inspectDataSource: Udesk.enums.inspectDataSources.survey.id,
                taskStatus:
                    privates.model.processStatus.MIXED_AUTOLOAD?.[
                        Udesk.enums.inspectDataSources.survey.id
                    ],
            };

            Udesk.ajax
                .post(url, [params_text, params_voice, params_ticket, params_video, params_survey])
                .then(
                    (resp) => {
                        Udesk.ui.notify.success(
                            this.props.route.name === 'informationCollectDataAddAuto'
                                ? `${UdeskLocales.current.components.pages.dataAdd.types.auto}${UdeskLocales.current.business.info.editSuccess}`
                                : `${UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index.name}${UdeskLocales.current.business.info.editSuccess}`
                        );
                    },
                    (reason) => {
                        Udesk.ui.notify.error(
                            reason.errorMsg ||
                                `${UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index.name}${UdeskLocales.current.business.info.editError}`
                        );
                    }
                );
        },

        // 2、自动抽检
        saveAutomaticSamplingInspection() {
            let conditions = Udesk.utils.object.deepCopy(this.privates.conditions);
            const fieldList = this.privates.model.customFields;

            if (conditions instanceof Array && conditions.length < 1) {
                return Udesk.ui.notify.error(
                    Udesk.utils.string.format(
                        UdeskLocales.current.business.info.cannotBeNull,
                        UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                            .automaticSamplingInspection
                    )
                );
            }

            if (conditions instanceof Array && conditions.length > 0) {
                conditions = conditions.map((condition) => {
                    if (
                        condition.baseFilter &&
                        condition.baseFilter.conditionList &&
                        condition.baseFilter.conditionList.length > 0
                    ) {
                        condition.baseFilter.conditionList = getQueryConditionList(
                            fieldList,
                            condition.baseFilter.conditionList
                        );
                    }
                    if (condition.sampleConf.sampleAvg) {
                        condition.sampleConf.sampleAvg = 1;
                    } else {
                        condition.sampleConf.sampleAvg = 0;
                    }
                    if (condition.sampleConf.sampleReCheck) {
                        condition.sampleConf.sampleReCheck = 1;
                    } else {
                        condition.sampleConf.sampleReCheck = 0;
                    }
                    return condition;
                });
            }

            let sampleNumberOrPercentIsNull = false;
            conditions.forEach((condition) => {
                if (condition.sampleConf.sampleForm === Udesk.enums.samplingTypes.random.id) {
                    if (
                        condition.sampleConf.random == null ||
                        condition.sampleConf.random.trim === ''
                    ) {
                        sampleNumberOrPercentIsNull = true;
                    }
                } else if (
                    condition.sampleConf.sampleForm === Udesk.enums.samplingTypes.proportional.id
                ) {
                    if (
                        condition.sampleConf.percent == null ||
                        condition.sampleConf.percent.toString().trim() === ''
                    ) {
                        sampleNumberOrPercentIsNull = true;
                    }
                }
            });

            if (sampleNumberOrPercentIsNull) {
                return Udesk.ui.notify.error(
                    Udesk.utils.string.format(
                        UdeskLocales.current.business.info.cannotBeNull,
                        UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                            .sampleNumberOrPercent
                    )
                );
            }

            const url1 = Udesk.business.apiPath.concatApiPath(
                `/autoMateTasks/samples/check`,
                this.props.sdkOptions
            );

            const data2 = conditions;
            const data3 = [
                {
                    ...this.privates.everyAgentCheckUpperLimit,
                    taskId: this.privates.model.taskId,
                },
                {
                    ...this.privates.everyAgentCheckFloorLimit,
                    taskId: this.privates.model.taskId,
                },
            ];
            const data1 = {
                sampleConfigList: data2.map((c) => c.sampleConf),
                flowConfigList: data3,
            };

            Udesk.ajax.post(url1, data1).then(
                () => {
                    const promiseList = [];

                    const url2 = Udesk.business.apiPath.concatApiPath(
                        `/autoMateTasks/samples`,
                        this.props.sdkOptions
                    );
                    promiseList.push(Udesk.ajax.post(url2, data2));

                    const url3 = Udesk.business.apiPath.concatApiPath(
                        `/flowConfigs`,
                        this.props.sdkOptions
                    );
                    promiseList.push(Udesk.ajax.post(url3, data3));

                    Promise.all(promiseList).then(
                        ([a, res]) => {
                            Udesk.ui.notify.success(UdeskLocales.current.business.info.saveSuccess);
                        },
                        (reason) => {
                            Udesk.ui.notify.error(
                                reason.errorMsg || UdeskLocales.current.business.info.saveError
                            );
                        }
                    );
                },
                (reason) => {
                    Udesk.ui.notify.error(
                        reason.errorMsg ||
                            /* 校验失败 */ UdeskLocales['current'].pages.tasks.manage.template
                                .automaticAdd.component.verificationFailed
                    );
                }
            );
        },
        conditionsChanged(conditions) {
            if (conditions instanceof Array) {
                this.privates.conditions = conditions;
                this.actions.update();
            }
        },
        onEveryAgentCheckUpperLimitStatusChange(e) {
            this.privates.everyAgentCheckUpperLimit.status = e.target.checked ? 1 : 0;
            this.actions.update();
        },
        onEveryAgentCheckUpperLimitChange(type, value) {
            this.privates.everyAgentCheckUpperLimit[type] = value;
            this.actions.update();
        },
        onEveryAgentCheckFloorLimitStatusChange(e) {
            this.privates.everyAgentCheckFloorLimit.status = e.target.checked ? 1 : 0;
            this.actions.update();
        },
        onEveryAgentCheckFloorLimitChange(type, value) {
            this.privates.everyAgentCheckFloorLimit[type] = value;
            this.actions.update();
        },
        // 3、自动分配
        saveAutomaticAllocation() {
            const fieldList = this.privates.model.customFields;
            let taskId = this.privates.model.taskId;
            let inspectorListisNull = false;

            let sampleAssign = Udesk.utils.object.deepCopy(this.privates.sampleAssign);
            sampleAssign.taskId = taskId;
            if (sampleAssign.assignModel === Udesk.enums.distributeTypes.average.id) {
                sampleAssign.assignConfList = [];
                if (
                    !Array.isArray(this.privates.model.processCreateStatus.inspectorList) ||
                    !this.privates.model.processCreateStatus.inspectorList.length
                ) {
                    Udesk.ui.notify.error(
                        UdeskLocales.current.business.notifyMessage
                            .AutomaticAllocationInspectorsIsNull
                    );
                    return;
                }
            } else {
                let assignConfList = sampleAssign.assignConfList;
                if (assignConfList && assignConfList.length > 0) {
                    assignConfList.forEach((rule) => {
                        if (rule.assignConf.assignType === Udesk.enums.inspectorTypes.some.id) {
                            if (
                                rule.assignConf.inspectors == null ||
                                rule.assignConf.inspectors.trim() === ''
                            ) {
                                inspectorListisNull = true;
                            }
                        }
                        if (
                            rule.baseFilter &&
                            rule.baseFilter.conditionList &&
                            rule.baseFilter.conditionList.length > 0
                        ) {
                            rule.baseFilter.conditionList = getQueryConditionList(
                                fieldList,
                                rule.baseFilter.conditionList
                            );
                        }
                    });
                }
            }

            let reviewAssign = Udesk.utils.object.deepCopy(this.privates.reviewAssign);
            reviewAssign.taskId = taskId;
            if (reviewAssign.assignModel === Udesk.enums.distributeTypes.average.id) {
                reviewAssign.assignConfList = [];
                if (
                    !Array.isArray(this.privates.model.processCreateStatus.inspectorList) ||
                    !this.privates.model.processCreateStatus.inspectorList.length
                ) {
                    Udesk.ui.notify.error(
                        UdeskLocales.current.business.notifyMessage
                            .AutomaticAllocationInspectorsIsNull
                    );
                    return;
                }
            } else {
                let assignConfList = reviewAssign.assignConfList;
                if (assignConfList && assignConfList.length > 0) {
                    assignConfList.forEach((rule) => {
                        if (rule.assignConf.assignType === Udesk.enums.inspectorTypes.some.id) {
                            if (
                                rule.assignConf.inspectors == null ||
                                rule.assignConf.inspectors.trim() === ''
                            ) {
                                inspectorListisNull = true;
                            }
                        }
                        if (
                            rule.baseFilter &&
                            rule.baseFilter.conditionList &&
                            rule.baseFilter.conditionList.length > 0
                        ) {
                            rule.baseFilter.conditionList = getQueryConditionList(
                                fieldList,
                                rule.baseFilter.conditionList
                            );
                        }
                    });
                }
            }

            let reviewAssignSecondLevel = Udesk.utils.object.deepCopy(
                this.privates.reviewAssignSecondLevel
            );
            reviewAssignSecondLevel.taskId = taskId;
            if (reviewAssignSecondLevel.assignModel === Udesk.enums.distributeTypes.average.id) {
                reviewAssignSecondLevel.assignConfList = [];
                if (
                    !Array.isArray(this.privates.model.processCreateStatus.inspectorList) ||
                    !this.privates.model.processCreateStatus.inspectorList.length
                ) {
                    Udesk.ui.notify.error(
                        UdeskLocales.current.business.notifyMessage
                            .AutomaticAllocationInspectorsIsNull
                    );
                    return;
                }
            } else if (
                reviewAssignSecondLevel.assignModel === Udesk.enums.distributeTypes.rule.id
            ) {
                let assignConfList = reviewAssignSecondLevel.assignConfList;
                if (assignConfList && assignConfList.length > 0) {
                    assignConfList.forEach((rule) => {
                        if (rule.assignConf.assignType === Udesk.enums.inspectorTypes.some.id) {
                            if (
                                rule.assignConf.inspectors == null ||
                                rule.assignConf.inspectors.trim() === ''
                            ) {
                                inspectorListisNull = true;
                            }
                        }
                        if (
                            rule.baseFilter &&
                            rule.baseFilter.conditionList &&
                            rule.baseFilter.conditionList.length > 0
                        ) {
                            rule.baseFilter.conditionList = getQueryConditionList(
                                fieldList,
                                rule.baseFilter.conditionList
                            );
                        }
                    });
                }
            }

            const defaultSampleAssignConf = {
                ...this.privates.defaultSampleAssignConf,
                inspectors: (this.privates.defaultSampleAssignConf.inspectorList || []).join(','),
                defaultFlag: 1,
            };
            const defaultReviewAssignConf = {
                ...this.privates.defaultReviewAssignConf,
                inspectors: (this.privates.defaultReviewAssignConf.inspectorList || []).join(','),
                defaultFlag: 1,
            };
            const defaultReviewAssignConfSecondLevel = {
                ...this.privates.defaultReviewAssignConfSecondLevel,
                inspectors: (
                    this.privates.defaultReviewAssignConfSecondLevel.inspectorList || []
                ).join(','),
                defaultFlag: 1,
            };
            if (
                defaultSampleAssignConf.assignType === Udesk.enums.inspectorTypes.some.id &&
                !defaultSampleAssignConf.inspectorList?.length
            ) {
                inspectorListisNull = true;
            }
            if (
                defaultReviewAssignConf.assignType === Udesk.enums.inspectorTypes.some.id &&
                !defaultReviewAssignConf.inspectorList?.length
            ) {
                inspectorListisNull = true;
            }
            if (
                defaultReviewAssignConfSecondLevel.assignType ===
                    Udesk.enums.inspectorTypes.some.id &&
                !defaultReviewAssignConfSecondLevel.inspectorList?.length
            ) {
                inspectorListisNull = true;
            }

            reviewAssignSecondLevel.enabledSecondLevelRecheck =
                reviewAssignSecondLevel.enabledSecondLevelRecheck ? 1 : 0;

            if (
                reviewAssignSecondLevel.enabledSecondLevelRecheck &&
                reviewAssignSecondLevel.assignModel === Udesk.enums.distributeTypes.specify.id &&
                reviewAssignSecondLevel.secondLevelInspectors === undefined
            ) {
                Udesk.ui.notify.error(
                    /* 请添加二级质检员 */ UdeskLocales.current.pages.tasks.manage.template
                        .automaticAdd.component.pleaseAddASecondLevelQualityInspector
                );
                return;
            }

            if (inspectorListisNull) {
                return Udesk.ui.notify.error(
                    Udesk.utils.string.format(
                        UdeskLocales.current.business.info.cannotBeNull,
                        UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                            .inspectorList
                    )
                );
            }
            sampleAssign.assignConfList.push({ assignConf: defaultSampleAssignConf });
            reviewAssign.assignConfList.push({ assignConf: defaultReviewAssignConf });
            reviewAssignSecondLevel.assignConfList.push({
                assignConf: defaultReviewAssignConfSecondLevel,
            });
            let params = [sampleAssign, reviewAssign, reviewAssignSecondLevel];

            const isComment =
                this.privates.type === Udesk.enums.inspectDataSources.eComment.id ||
                this.privates.type === Udesk.enums.inspectDataSources.mComment.id;

            if (isComment) {
                params = [sampleAssign];
            }

            let url = Udesk.business.apiPath.concatApiPath(
                `/autoMateTasks/assigns`,
                this.props.sdkOptions
            );
            Udesk.ajax.post(url, params).then(
                (resp) => {
                    Udesk.ui.notify.success(UdeskLocales.current.business.info.saveSuccess);
                },
                (reason) => {
                    Udesk.ui.notify.error(
                        reason.errorMsg || UdeskLocales.current.business.info.saveError
                    );
                }
            );
        },

        sampleAssignListChanged(list) {
            const sampleAssign = this.privates.sampleAssign;
            sampleAssign.assignConfList = list;
            this.actions.update();
        },

        reviewAssignListChanged(list) {
            const reviewAssign = this.privates.reviewAssign;
            reviewAssign.assignConfList = list;
            this.actions.update();
        },

        reviewAssignSecondLevelListChanged(list) {
            const reviewAssignSecondLevel = this.privates.reviewAssignSecondLevel;
            reviewAssignSecondLevel.assignConfList = list;
            this.actions.update();
        },

        // 4、自动推送
        saveAutomaticPush() {
            // let pushRules = Udesk.utils.object.deepCopy(this.privates.pushRules);
            // const fieldList = this.privates.model.customFields;

            // if (pushRules instanceof Array && pushRules.length < 1) {
            //     return Udesk.ui.notify.error(
            //         Udesk.utils.string.format(
            //             UdeskLocales.current.business.info.cannotBeNull,
            //             UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index.automaticPush
            //         )
            //     );
            // }

            // pushRules.forEach(rule => {
            //     if (rule.baseFilter && rule.baseFilter.conditionList && rule.baseFilter.conditionList.length > 0) {
            //         rule.baseFilter.conditionList = getQueryConditionList(fieldList, rule.baseFilter.conditionList);
            //     }
            // });
            let { automaticPushConfigList } = this.privates;
            if (automaticPushConfigList instanceof Array && automaticPushConfigList.length < 1) {
                return Udesk.ui.notify.error(
                    Udesk.utils.string.format(
                        UdeskLocales.current.business.info.cannotBeNull,
                        UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                            .automaticPush
                    )
                );
            }

            let url = Udesk.business.apiPath.concatApiPath(
                `/autoMateTasks/monitor`,
                this.props.sdkOptions
            );
            let isWechatQa = [
                Udesk.enums.inspectDataSources.wechatDialogue.id,
                Udesk.enums.inspectDataSources.wechatRadio.id,
            ].includes(this.privates.type);
            if (isWechatQa) {
                url = Udesk.business.apiPath.concatApiPath(
                    `/autoMateTasks/wecom/monitor`,
                    this.props.sdkOptions
                );
            }
            Udesk.ajax.post(url, automaticPushConfigList).then(
                (resp) => {
                    Udesk.ui.notify.success(UdeskLocales.current.business.info.saveSuccess);
                },
                (reason) => {
                    Udesk.ui.notify.error(
                        reason.errorMsg || UdeskLocales.current.business.info.saveError
                    );
                }
            );
        },

        pushRulesChanged(rules) {
            this.privates.pushRules = rules;
            this.actions.update();
        },

        deleteItem(index, item) {
            let { configuration } = item;
            let id = configuration._id;
            let { automaticPushConfigList } = this.privates;
            this.privates.automaticPushConfigList = automaticPushConfigList.filter(
                (item) => item._id !== id
            );
            this.actions.update();
        },

        addItem(messageType) {
            this.privates.automaticPushConfigList.push(
                createAutomaticPushConfig(messageType, this.privates.model.taskId)
            );
            // window.console.log('addItem', 101,this.privates.automaticPushConfigList)
            this.actions.update();
        },
        addCaseItem() {
            this.privates.caseConfigList.push({
                _id: Udesk.utils.string.uuid(),
            });
            this.actions.update();
        },
        deleteCaseItem(index) {
            this.privates.caseConfigList = this.privates.caseConfigList.filter(
                (item, i) => index !== i
            );
            this.actions.update();
        },
        onCaseItemChange(index, newValues) {
            if (this.privates.caseConfigList[index]) {
                this.privates.caseConfigList[index] = {
                    ...this.privates.caseConfigList[index],
                    ...newValues,
                };
                this.actions.update();
            }
        },
        onMassageConfigurationChange(condition, newCheckedTypes, id) {
            // condition = newConfiguration;

            this.privates.automaticPushConfigList.forEach((automaticPushConfig) => {
                if (
                    automaticPushConfig._id === id &&
                    automaticPushConfig.monitorConf &&
                    Array.isArray(automaticPushConfig.monitorConf.pushConf)
                ) {
                    for (let i = 0; i < automaticPushConfig.monitorConf.pushConf.length; i++) {
                        let item = automaticPushConfig.monitorConf.pushConf[i];
                        if (newCheckedTypes.includes(item.actionType)) {
                            item.enabled = 1;
                        } else {
                            item.enabled = 0;
                        }
                    }
                }
            });

            this.actions.update();
        },
        onConfigurationChange(newConfiguration) {
            this.privates.automaticPushConfigList.forEach((automaticPushConfig) => {
                if (automaticPushConfig._id === newConfiguration._id) {
                    Object.assign(automaticPushConfig, newConfiguration);
                }
            });

            this.actions.update();
        },

        // 5、自动评估
        saveAutomaticAssess() {
            let assessRules = Udesk.utils.object.deepCopy(this.privates.assessRules);
            const fieldList = this.privates.model.customFields;

            if (assessRules instanceof Array && assessRules.length < 1) {
                return Udesk.ui.notify.error(
                    Udesk.utils.string.format(
                        UdeskLocales.current.business.info.cannotBeNull,
                        UdeskLocales.current.pages.tasks.manage.template.automaticAdd.index
                            .automaticAssess
                    )
                );
            }

            assessRules.forEach((rule) => {
                if (
                    rule.baseFilter &&
                    rule.baseFilter.conditionList &&
                    rule.baseFilter.conditionList.length > 0
                ) {
                    rule.baseFilter.conditionList = getQueryConditionList(
                        fieldList,
                        rule.baseFilter.conditionList
                    );
                }
            });

            let url = Udesk.business.apiPath.concatApiPath(
                `/autoMateTasks/assessment`,
                this.props.sdkOptions
            );
            Udesk.ajax.post(url, assessRules).then(
                (resp) => {
                    Udesk.ui.notify.success(UdeskLocales.current.business.info.saveSuccess);
                },
                (reason) => {
                    Udesk.ui.notify.error(
                        reason.errorMsg || UdeskLocales.current.business.info.saveError
                    );
                }
            );
        },

        assessRulesChanged(rules) {
            this.privates.assessRules = rules;
            this.actions.update();
        },

        // 案例库
        saveCaseLibrary() {
            postAutoMateTasksCaseByTaskId(
                this.privates.caseConfigList.map((item) => {
                    return {
                        taskType: 9,
                        autoMateCaseConf: { ...item, syncHis: item.syncHis ? 1 : 0 },
                        taskId: this.privates.model.taskId,
                    };
                }),
                {
                    segments: {
                        taskId: this.privates.model.taskId,
                    },
                    successMsg: UdeskLocales.current.business.info.saveSuccess,
                }
            ).then((resp) => {});
        },
        //5、抽检目标
        samplingTargetSave() {
            this.privates.samplingTargetRef.current?.formInstance?.submit?.();
        },

        // 6、申诉复核
        saveReexaminationComplaint() {
            let reviewOptions = this.privates.reviewOptions;
            let reviewOptionsExport = this.privates.reviewOptionsExport;
            let spoktOptions = this.privates.spoktOptions;
            let spoketOptionsExport = this.privates.spoketOptionsExport;
            let inspectionOptionsExport = this.privates.inspectionOptionsExport;
            let fastSampleInDetailList = this.privates.fastSampleInDetailList;
            let permitCustomReasonList = this.privates.permitCustomReasonList;
            let permitComplainCount = this.privates.permitComplainCount;
            let complainPeriod = this.privates.complainPeriod;
            let reviewAging = this.privates.reviewAging;
            let callDetailShowConfigList = this.privates.callDetailShowConfigList;
            let complainPeriodMode = this.privates.complainPeriodMode;
            let refreshComplainPeriodAndNum = this.privates.refreshComplainPeriodAndNum;
            let complainCycle = this.privates.complainCycle;
            let complainScope = this.privates.complainScope;
            let complainDeadTime = this.privates.complainDeadTime;
            let reviewCycle = this.privates.reviewCycle;
            let reviewScope = this.privates.reviewScope;
            let reviewDeadTime = this.privates.reviewDeadTime;
            let complainDeadCount = this.privates.complainDeadCount;
            let finalReview = this.privates.finalReview;
            let sdkShowCaseLibrary = this.privates.sdkShowCaseLibrary;

            let checkConf = { ...this.privates.appealOptionsExport, ...this.privates.appaelable };

            if (reviewOptions && reviewOptions.length > 0) {
                reviewOptions.forEach((option) => {
                    if (option === Udesk.enums.reviewlistResultOptions.checkResult.id) {
                        checkConf.checkResult = 1;
                    } else if (option === Udesk.enums.reviewlistResultOptions.checkRecord.id) {
                        checkConf.checkRecord = 1;
                    } else if (
                        option === Udesk.enums.reviewlistResultOptions.reviewAgentHidden.id
                    ) {
                        checkConf.reviewAgentHidden = 1;
                    }
                });
            }

            if (spoktOptions && spoktOptions.length > 0) {
                spoktOptions.forEach((option) => {
                    if (option === Udesk.enums.spoktListResultOptions.sampleResult.id) {
                        checkConf.sampleResult = 1;
                    } else if (option === Udesk.enums.spoktListResultOptions.sampleRecord.id) {
                        checkConf.sampleRecord = 1;
                    } else if (option === Udesk.enums.spoktListResultOptions.sampleAgentHidden.id) {
                        checkConf.sampleAgentHidden = 1;
                    }
                });
            }

            if (reviewOptionsExport && reviewOptionsExport.length > 0) {
                reviewOptionsExport.forEach((option) => {
                    if (
                        option ===
                        Udesk.enums.reviewlistResultOptionsExportIphone.checkExportAddCallInfo.id
                    ) {
                        checkConf.checkExportAddCallInfo = 1;
                    }
                });
            }

            if (spoketOptionsExport && spoketOptionsExport.length > 0) {
                spoketOptionsExport.forEach((option) => {
                    if (
                        option ===
                        Udesk.enums.spoktListResultOptionsExportIphone.sampleExportAddCallInfo.id
                    ) {
                        checkConf.sampleExportAddCallInfo = 1;
                    }
                });
            }
            if (inspectionOptionsExport && inspectionOptionsExport.length > 0) {
                inspectionOptionsExport.forEach((option) => {
                    if (
                        option ===
                        Udesk.enums.inspectionListResultOptionsExportIphone
                            .inspectionExportAddCallInfo.id
                    ) {
                        checkConf.inspectionExportAddCallInfo = 1;
                    }
                });
            }

            if (fastSampleInDetailList && fastSampleInDetailList.length > 0) {
                fastSampleInDetailList.forEach((option) => {
                    if (
                        option === Udesk.enums.fastSampleInDetailList.fastSampleInInspectDetail.id
                    ) {
                        checkConf.fastSampleInInspectDetail = 1;
                    } else if (
                        option === Udesk.enums.fastSampleInDetailList.fastSampleInSampleDetail.id
                    ) {
                        checkConf.fastSampleInSampleDetail = 1;
                    } else if (
                        option === Udesk.enums.fastSampleInDetailList.fastSampleInReviewDetail.id
                    ) {
                        checkConf.fastSampleInReviewDetail = 1;
                    }
                });
            }

            if (permitCustomReasonList && permitCustomReasonList.length > 0) {
                permitCustomReasonList.forEach((option) => {
                    if (option === Udesk.enums.permitCustomReasonList.permitCustomReason.id) {
                        checkConf.permitCustomReason = 1;
                    }
                });
            }

            if (complainPeriod || complainPeriod === 0) {
                checkConf.complainPeriod = complainPeriod;
            }

            if (permitComplainCount || complainPeriod === 0) {
                checkConf.permitComplainCount = permitComplainCount;
            }

            checkConf.reviewAging = reviewAging;

            if (callDetailShowConfigList && callDetailShowConfigList.length > 0) {
                callDetailShowConfigList.forEach((item) => {
                    if (item === '1') {
                        checkConf.showSilenceDuration = 1;
                        checkConf.overSecondsDurationShow =
                            this.privates.overSecondsDurationShow || 30;
                    }
                    if (item === '2') {
                        checkConf.playBarShowEmotion = 1;
                    }
                    if (item === '3') {
                        checkConf.playBarShowSmartTag = 1;
                    }
                    if (item === '4') {
                        checkConf.playBarShowPoint = 1;
                    }
                });
            }

            checkConf.complainPeriodMode = complainPeriodMode;
            checkConf.refreshComplainPeriodAndNum = refreshComplainPeriodAndNum;

            if (complainPeriodMode === AppealConfigModeMap.CutOff) {
                // 申诉截止时间必填且需要完整
                // 复核截止时间非必填，但如果有填写，必须完整
                if (
                    !complainCycle ||
                    !checkRequird({
                        frequency: complainCycle,
                        week: complainScope,
                        day: complainScope,
                        time: complainDeadTime,
                    }) ||
                    !checkRequird({
                        frequency: reviewCycle,
                        week: reviewScope,
                        day: reviewScope,
                        time: reviewDeadTime,
                    })
                ) {
                    message.error(
                        /* 请完善申诉配置！ */ UdeskLocales['current'].pages.tasks.manage.template
                            .automaticAdd.component.pleaseImproveTheAppealConfiguration
                    );
                    return;
                }
            }

            let samplePeriodMode = this.privates.samplePeriodMode;
            let sampleAging = this.privates.sampleAging;
            let sampleCycle = this.privates.sampleCycle;
            let sampleScope = this.privates.sampleScope;
            let sampleDeadTime = this.privates.sampleDeadTime;
            if (
                samplePeriodMode === SamplePeriodModeMap.SAMPLE_DEADLINE &&
                (!sampleCycle ||
                    !checkRequird({
                        frequency: sampleCycle,
                        week: sampleScope,
                        day: sampleScope,
                        time: sampleDeadTime,
                    }))
            ) {
                message.error(
                    /* 请完善抽检截止时间配置！ */UdeskLocales['current'].pages.tasks.manage.template.automaticAdd.component.pleaseImproveTheSamplingDeadlineConfiguration
                );
                return;
            }

            checkConf = {
                ...checkConf,
                complainCycle,
                complainScope,
                complainDeadTime,
                reviewCycle,
                reviewScope,
                reviewDeadTime,
                complainDeadCount,
                finalReview,
                sdkShowCaseLibrary,
                samplePeriodMode,
                sampleAging,
                sampleCycle,
                sampleScope,
                sampleDeadTime,
            };

            let params = {
                taskId: this.privates.model.taskId,
                taskType: 5,
                checkConf: checkConf,
            };
            let url = Udesk.business.apiPath.concatApiPath(
                `/autoMateTasks/checks`,
                this.props.sdkOptions
            );
            Udesk.ajax.post(url, params).then(
                (resp) => {
                    let data = {
                        taskId: this.privates.model.taskId,
                        remarkModel: this.privates.remarkModel,
                    };
                    if (this.privates.remarkModelId) {
                        putInspectionRemarkModelConfigsById(data, {
                            segments: {
                                id: this.privates.remarkModelId,
                            },
                            successMsg: UdeskLocales.current.business.info.saveSuccess,
                        }).then(() => {
                            this.actions.getRemark();
                        });
                    } else {
                        postInspectionRemarkModelConfigs(data, {
                            successMsg: UdeskLocales.current.business.info.saveSuccess,
                        }).then(() => {
                            this.actions.getRemark();
                        });
                    }
                },
                (reason) => {
                    Udesk.ui.notify.error(
                        reason.errorMsg || UdeskLocales.current.business.info.saveError
                    );
                }
            );
        },
        getRemark() {
            getInspectionRemarkModelConfigsById({
                segments: {
                    id: this.privates.model.taskId,
                },
            }).then((resp) => {
                if (resp.data) {
                    this.privates.remarkModel = resp.data.remarkModel ?? '';
                    this.privates.remarkModelId = resp.data.id ?? null;
                }
            });
        },
        close() {
            const routeOptions = {
                history: this.props.history,
                routeName: 'tasksIndex',
            };
            Udesk.ui.routing.transitionTo(routeOptions);
        },
        sendAjaxToNext() {
            let url = Udesk.business.apiPath.concatApiPath(
                `/inspectionTasks/processStatus/${this.privates.model.processCreateStatus.id}`,
                this.props.sdkOptions
            );
            const { props } = this;
            let hasFeature = props.sdkOptions.props.task
                ? props.sdkOptions.props.task._hasFeature
                : null;
            const openNotification = () => {
                const key = `open${Date.now()}`;
                const btn = (
                    <Button
                        type="primary"
                        prefixCls="udesk-qa-ui-btn"
                        size="small"
                        onClick={() => {
                            this.actions.close();
                            notification.close(key);
                        }}
                    >
                        {UdeskLocales.current.labels.ok}
                    </Button>
                );
                notification.open({
                    prefixCls: 'udesk-qa-ui-notification',
                    message: UdeskLocales.current.business.notifyMessage.illegalTitle,
                    description: UdeskLocales.current.business.notifyMessage.illegalMessage,
                    btn,
                    key,
                    onClose: this.actions.close,
                    duration: 0,
                    style: {
                        top: '60px',
                    },
                });
            };
            if (
                this.privates.model.processCreateStatus.inspectDataSource === 1 ||
                this.privates.model.processCreateStatus.inspectDataSource === 2 ||
                this.privates.model.processCreateStatus.inspectDataSource ===
                    Udesk.enums.inspectDataSources.survey.id ||
                this.privates.model.processCreateStatus.inspectDataSource ===
                    Udesk.enums.inspectDataSources.mixedType.id ||
                this.privates.model.processCreateStatus.inspectDataSource === 17 ||
                this.privates.model.processCreateStatus.inspectDataSource ===
                    Udesk.enums.inspectDataSources.feishuGroup.id ||
                this.privates.model.processCreateStatus.inspectDataSource ===
                    Udesk.enums.inspectDataSources.taobao.id
            ) {
                if (
                    (hasFeature && !hasFeature('task:template:manual:view')) ||
                    (hasFeature && !hasFeature('task:template:manual:import')) ||
                    (hasFeature && !hasFeature('task:template:manual:history'))
                ) {
                    openNotification();
                } else {
                    Udesk.ajax.put(url, { processStatus: 6 }).then(
                        (resp) => {
                            let routeOptions = {
                                history: this.props.history,
                                routeName: 'tasksManualAddCreateIndex',
                                pathParams: {
                                    taskId: this.privates.model.processCreateStatus.id,
                                },
                            };
                            Udesk.ui.routing.transitionTo(routeOptions);
                        },
                        (reason) => {
                            Udesk.ui.notify.error(
                                reason.errorMsg ||
                                    Udesk.utils.string.format(
                                        UdeskLocales.current.business.info.loadError,
                                        UdeskLocales.current.pages.tasks.manage.template.basicInfo
                                            .index.title
                                    )
                            );
                        }
                    );
                }
            }
        },
        handleNext() {
            let url2 = Udesk.business.apiPath.concatApiPath(
                `/inspectionTasks/nextCheck/${this.privates.model.taskId}`,
                this.props.sdkOptions
            );
            if (
                this.privates.model.processCreateStatus.related === 1 &&
                Udesk.business.task.isTextDialogue(
                    this.privates.model.processCreateStatus.inspectDataSource
                )
            ) {
                this.actions.exitBoot();
                return;
            }
            Udesk.ajax.post(url2, { processStatus: 4 }).then(
                (resp) => {
                    if (resp.data) {
                        this.actions.sendAjaxToNext();
                    } else {
                        Udesk.ui.notify.error(
                            UdeskLocales.current.business.notifyMessage.skipMessage
                        );
                    }
                },
                (reason) => {
                    Udesk.ui.notify.error(reason.errorMsg);
                }
            );
        },
        exitBoot() {
            let url = Udesk.business.apiPath.concatApiPath(
                `/inspectionTasks/processStatus/${this.privates.model.taskId}`,
                this.props.sdkOptions
            );
            Udesk.ajax.put(url, { processStatus: -1 }).then(
                (resp) => {
                    const routeOptions = {
                        history: this.props.history,
                        routeName: 'tasksAutomaticAddIndex',
                        pathParams: { taskId: this.privates.model.taskId },
                    };
                    Udesk.ui.routing.transitionTo(routeOptions);
                },
                (reason) => {
                    Udesk.ui.notify.error(reason.errorMsg);
                }
            );
        },

        //高级筛选器
        openCustomFilterModal() {
            this.privates.isFilterVisible = true;
            this.actions.update();
        },
        handleConditionCancel() {
            this.privates.isFilterVisible = false;
            this.actions.update();
        },
        handleConditionApply(conditionList, customJudgeLogic, judgeStrategy) {
            // let { editKey } = this.privates;
            this.privates.conditionList = conditionList;
            this.privates.model.automaticAdd.baseFilter.judgeStrategy = judgeStrategy;
            if (judgeStrategy !== 3) {
                this.privates.model.automaticAdd.baseFilter.customJudgeLogic = '';
            } else {
                this.privates.model.automaticAdd.baseFilter.customJudgeLogic = customJudgeLogic;
            }
            this.privates.customId = null;
            this.privates.customName = null;

            this.actions.update();
        },
        handleConditionApplyText(conditionList, customJudgeLogic, judgeStrategy) {
            // let { editKey } = this.privates;
            this.privates.conditionList_text = conditionList;
            this.privates.model.automaticAdd.text.baseFilter.judgeStrategy = judgeStrategy;
            if (judgeStrategy !== 3) {
                this.privates.model.automaticAdd.text.baseFilter.customJudgeLogic = '';
            } else {
                this.privates.model.automaticAdd.text.baseFilter.customJudgeLogic =
                    customJudgeLogic;
            }
            this.privates.customId = null;
            this.privates.customName = null;

            this.actions.update();
        },
        handleConditionApplyVoice(conditionList, customJudgeLogic, judgeStrategy) {
            // let { editKey } = this.privates;
            this.privates.conditionList_voice = conditionList;
            this.privates.model.automaticAdd.voice.baseFilter.judgeStrategy = judgeStrategy;
            if (judgeStrategy !== 3) {
                this.privates.model.automaticAdd.voice.baseFilter.customJudgeLogic = '';
            } else {
                this.privates.model.automaticAdd.voice.baseFilter.customJudgeLogic =
                    customJudgeLogic;
            }
            this.privates.customId = null;
            this.privates.customName = null;

            this.actions.update();
        },
        handleConditionApplyTicket(conditionList, customJudgeLogic, judgeStrategy) {
            // let { editKey } = this.privates;
            this.privates.conditionList_ticket = conditionList;
            this.privates.model.automaticAdd.ticket.baseFilter.judgeStrategy = judgeStrategy;
            if (judgeStrategy !== 3) {
                this.privates.model.automaticAdd.ticket.baseFilter.customJudgeLogic = '';
            } else {
                this.privates.model.automaticAdd.ticket.baseFilter.customJudgeLogic =
                    customJudgeLogic;
            }
            this.privates.customId = null;
            this.privates.customName = null;

            this.actions.update();
        },
        handleConditionApplyVideo(conditionList, customJudgeLogic, judgeStrategy) {
            // let { editKey } = this.privates;
            this.privates.conditionList_video = conditionList;
            this.privates.model.automaticAdd.video.baseFilter.judgeStrategy = judgeStrategy;
            if (judgeStrategy !== 3) {
                this.privates.model.automaticAdd.video.baseFilter.customJudgeLogic = '';
            } else {
                this.privates.model.automaticAdd.video.baseFilter.customJudgeLogic =
                    customJudgeLogic;
            }
            this.privates.customId = null;
            this.privates.customName = null;

            this.actions.update();
        },
        handleConditionApplySurvey(conditionList, customJudgeLogic, judgeStrategy) {
            // let { editKey } = this.privates;
            this.privates.conditionList_survey = conditionList;
            this.privates.model.automaticAdd.survey.baseFilter.judgeStrategy = judgeStrategy;
            if (judgeStrategy !== 3) {
                this.privates.model.automaticAdd.survey.baseFilter.customJudgeLogic = '';
            } else {
                this.privates.model.automaticAdd.survey.baseFilter.customJudgeLogic =
                    customJudgeLogic;
            }
            this.privates.customId = null;
            this.privates.customName = null;

            this.actions.update();
        },
        onTimingAddChange(isAutoExecute, autoMateLoadConf, shouldUpdate) {
            this.privates.model.automaticAdd.isAutoExecute = isAutoExecute;
            if (shouldUpdate) {
                this.privates.model.automaticAdd.autoMateLoadConf = autoMateLoadConf;
            }
            this.actions.update();
        },

        onTimingAddChangeText(isAutoExecute, autoMateLoadConf, shouldUpdate) {
            this.privates.model.automaticAdd.text.isAutoExecute = isAutoExecute;
            if (shouldUpdate) {
                this.privates.model.automaticAdd.text.autoMateLoadConf = autoMateLoadConf;
            }
            this.actions.update();
        },

        onTimingAddChangeVoice(isAutoExecute, autoMateLoadConf, shouldUpdate) {
            this.privates.model.automaticAdd.voice.isAutoExecute = isAutoExecute;
            if (shouldUpdate) {
                this.privates.model.automaticAdd.voice.autoMateLoadConf = autoMateLoadConf;
            }
            this.actions.update();
        },

        onTimingAddChangeTicket(isAutoExecute, autoMateLoadConf, shouldUpdate) {
            this.privates.model.automaticAdd.ticket.isAutoExecute = isAutoExecute;
            if (shouldUpdate) {
                this.privates.model.automaticAdd.ticket.autoMateLoadConf = autoMateLoadConf;
            }
            this.actions.update();
        },

        onTimingAddChangeVideo(isAutoExecute, autoMateLoadConf, shouldUpdate) {
            this.privates.model.automaticAdd.video.isAutoExecute = isAutoExecute;
            if (shouldUpdate) {
                this.privates.model.automaticAdd.video.autoMateLoadConf = autoMateLoadConf;
            }
            this.actions.update();
        },

        onTimingAddChangeSurvey(isAutoExecute, autoMateLoadConf, shouldUpdate) {
            this.privates.model.automaticAdd.survey.isAutoExecute = isAutoExecute;
            if (shouldUpdate) {
                this.privates.model.automaticAdd.survey.autoMateLoadConf = autoMateLoadConf;
            }
            this.actions.update();
        },

        editFilterOhter(list, radioValue, customInfo) {
            this.privates.isFilterVisible = true;
            this.privates.judgeStrategyList = radioValue || 1;
            // this.privates.customJudgeLogicList = customInfo || '';
            this.privates.conditionList = list || [];
            this.actions.update();
        },

        editFilterOhterText(list, radioValue, customInfo) {
            this.privates.isFilterVisible = true;
            this.privates.judgeStrategyList_text = radioValue || 1;
            // this.privates.customJudgeLogicList = customInfo || '';
            this.privates.conditionList_text = list || [];
            this.actions.update();
        },

        editFilterOhterVoice(list, radioValue, customInfo) {
            this.privates.isFilterVisible = true;
            this.privates.judgeStrategyList_voice = radioValue || 1;
            // this.privates.customJudgeLogicList = customInfo || '';
            this.privates.conditionList_voice = list || [];
            this.actions.update();
        },

        editFilterOhterTicket(list, radioValue, customInfo) {
            this.privates.isFilterVisible = true;
            this.privates.judgeStrategyList_ticket = radioValue || 1;
            // this.privates.customJudgeLogicList = customInfo || '';
            this.privates.conditionList_ticket = list || [];
            this.actions.update();
        },

        editFilterOhterVideo(list, radioValue, customInfo) {
            this.privates.isFilterVisible = true;
            this.privates.judgeStrategyList_video = radioValue || 1;
            // this.privates.customJudgeLogicList = customInfo || '';
            this.privates.conditionList_video = list || [];
            this.actions.update();
        },

        editFilterOhterSurvey(list, radioValue, customInfo) {
            this.privates.isFilterVisible = true;
            this.privates.judgeStrategyList_survey = radioValue || 1;
            // this.privates.customJudgeLogicList = customInfo || '';
            this.privates.conditionList_survey = list || [];
            this.actions.update();
        },

        fieldsFilterChange(data) {
            let obj = Udesk.enums.fieldOperators;
            let list = [];
            data.forEach((item) => {
                if (item.value) {
                    if (
                        item.field &&
                        item.field.fieldType === 4 &&
                        item.field.optionValueList &&
                        item.field.optionValueList.length > 0
                    ) {
                        let str =
                            item.field.label +
                            ' ' +
                            obj[item.operator].name +
                            ' ' +
                            getOptionValue(item.value, item.field.optionValueList);
                        list = [...list, str];
                    } else if (Array.isArray(item.value)) {
                        let str = '';
                        item.value.forEach((items) => {
                            if (items.agentName) {
                                str += items.agentName + ',';
                            }
                        });
                        list = [
                            ...list,
                            item.field.label +
                                ' ' +
                                obj[item.operator].name +
                                ' ' +
                                str.substring(0, str.length - 1),
                        ];
                    } else if (typeof item.value === 'object') {
                        let str =
                            item.field.label +
                            ' ' +
                            obj[item.operator].name +
                            ' ' +
                            (item.value.agentName ||
                                item.value.agentGroupName ||
                                item.value.tagName ||
                                item.value.realname ||
                                item.value.departmentName ||
                                '');
                        list = [...list, str];
                    } else if (typeof item.value === 'string') {
                        let str =
                            item.field.label + ' ' + obj[item.operator].name + ' ' + item.value;
                        list = [...list, str];
                    } else {
                        let str =
                            item.field.label + ' ' + obj[item.operator].name + ' ' + item.value;
                        list = [...list, str];
                    }
                } else {
                    let str = item.field.label + ' ' + obj[item.operator].name;
                    list = [...list, str];
                }
            });
            return list.map((item, index) => {
                return (
                    <div
                        style={{
                            color: 'rgba(0, 0, 0, 0.65)',
                            marginBottom: index + 1 === list.length ? '0px' : '8px',
                        }}
                    >
                        {index + 1}. {item}
                    </div>
                );
            });
        },
        onAssignTypeChange(e) {
            this.privates.assignShowType = e.target.value;
            this.actions.update();
        },
        onRemarkModelChange(e) {
            this.privates.remarkModel = e.target.value;
            this.actions.update();
        },
    };
    //#endregion

    //#region Life Cycle
    onModelResolved(model) {
        // 准备自动添加数据
        let automaticAdd = model.automaticAdd;
        if (this.privates.type !== Udesk.enums.inspectDataSources.mixedType.id) {
            if (automaticAdd.baseFilter) {
                this.actions.handleConditionApply(
                    automaticAdd.baseFilter.conditionList,
                    automaticAdd.baseFilter.customJudgeLogic,
                    automaticAdd.baseFilter.judgeStrategy
                );
            }
        } else {
            if (automaticAdd.text.baseFilter) {
                this.actions.handleConditionApplyText(
                    automaticAdd.text.baseFilter.conditionList,
                    automaticAdd.text.baseFilter.customJudgeLogic,
                    automaticAdd.text.baseFilter.judgeStrategy
                );
            }
            if (automaticAdd.voice.baseFilter) {
                this.actions.handleConditionApplyVoice(
                    automaticAdd.voice.baseFilter.conditionList,
                    automaticAdd.voice.baseFilter.customJudgeLogic,
                    automaticAdd.voice.baseFilter.judgeStrategy
                );
            }
            if (automaticAdd.ticket.baseFilter) {
                this.actions.handleConditionApplyTicket(
                    automaticAdd.ticket.baseFilter.conditionList,
                    automaticAdd.ticket.baseFilter.customJudgeLogic,
                    automaticAdd.ticket.baseFilter.judgeStrategy
                );
            }
            if (automaticAdd.video.baseFilter) {
                this.actions.handleConditionApplyVideo(
                    automaticAdd.video.baseFilter.conditionList,
                    automaticAdd.video.baseFilter.customJudgeLogic,
                    automaticAdd.video.baseFilter.judgeStrategy
                );
            }

            if (automaticAdd.survey.baseFilter) {
                this.actions.handleConditionApplySurvey(
                    automaticAdd.survey.baseFilter.conditionList,
                    automaticAdd.survey.baseFilter.customJudgeLogic,
                    automaticAdd.survey.baseFilter.judgeStrategy
                );
            }
        }

        // 准备自动抽检数据
        let autoSample = model.autoSample;

        if (autoSample && autoSample instanceof Array && autoSample.length > 0) {
            this.privates.conditions = autoSample;
        }

        // 准备自动分配数据
        let autoAssign = model.autoAssign;
        if (autoAssign && autoAssign instanceof Array && autoAssign.length > 0) {
            autoAssign.forEach((item) => {
                let assignConfList = item.assignConfList || [];
                if (
                    assignConfList &&
                    assignConfList instanceof Array &&
                    assignConfList.length > 0
                ) {
                    assignConfList.forEach((option) => {
                        if (
                            option.assignConf &&
                            option.assignConf.assignType === Udesk.enums.inspectorTypes.some.id
                        ) {
                            if (!option.assignConf.inspectorList) {
                                if (option.assignConf.inspectors) {
                                    option.assignConf.inspectorList = option.assignConf.inspectors
                                        .split(',')
                                        .map((item) => ({
                                            id: parseInt(item, 10),
                                            realname: '--', // 后端没有回传对象，回显会有问题
                                        }));
                                } else {
                                    option.assignConf.inspectorList = [];
                                }
                            }
                        }
                    });
                }
                if (item.taskType === 2) {
                    this.privates.sampleAssign = {
                        ...item,
                        assignConfList: item.assignConfList.filter(
                            (c) => !c.assignConf.defaultFlag
                        ),
                    };
                    const defaultSampleAssignConf = item.assignConfList.filter(
                        (c) => c.assignConf.defaultFlag === 1
                    );
                    if (defaultSampleAssignConf?.length) {
                        let assignConf = defaultSampleAssignConf[0]?.assignConf ?? {};
                        assignConf.inspectorList = (assignConf.inspectorList || []).map(
                            (i) => i.id
                        );
                        this.privates.defaultSampleAssignConf = assignConf;
                    }
                }
                if (item.taskType === 3) {
                    this.privates.reviewAssign = {
                        ...item,
                        assignConfList: item.assignConfList.filter(
                            (c) => !c.assignConf.defaultFlag
                        ),
                    };
                    const defaultReviewAssignConf = item.assignConfList.filter(
                        (c) => c.assignConf.defaultFlag === 1
                    );
                    if (defaultReviewAssignConf?.length) {
                        let assignConf = defaultReviewAssignConf[0]?.assignConf ?? {};
                        assignConf.inspectorList = (assignConf.inspectorList || []).map(
                            (i) => i.id
                        );
                        this.privates.defaultReviewAssignConf = assignConf;
                    }
                }
                if (item.taskType === 16) {
                    this.privates.reviewAssignSecondLevel = {
                        ...item,
                        assignConfList: item.assignConfList.filter(
                            (c) => !c.assignConf.defaultFlag
                        ),
                    };
                    const defaultReviewAssignConfSecondLevel = item.assignConfList.filter(
                        (c) => c.assignConf.defaultFlag === 1
                    );
                    if (defaultReviewAssignConfSecondLevel?.length) {
                        let assignConf = defaultReviewAssignConfSecondLevel[0]?.assignConf ?? {};
                        assignConf.inspectorList = (assignConf.inspectorList || []).map(
                            (i) => i.id
                        );
                        this.privates.defaultReviewAssignConfSecondLevel = assignConf;
                    }
                }
            });

            // 这里，兼容老数据：没有新数据，且二级复核已开启
            const hasOldSecondLevelData =
                !autoAssign.some((item) => item.taskType === 16) &&
                this.privates.reviewAssign.enabledSecondLevelRecheck === 1;

            if (hasOldSecondLevelData) {
                this.privates.reviewAssignSecondLevel = {
                    ...this.privates.reviewAssignSecondLevel,
                    assignModel: Udesk.enums.distributeTypes.specify.id,
                    enabledSecondLevelRecheck: this.privates.reviewAssign.enabledSecondLevelRecheck,
                    secondLevelInspectors: this.privates.reviewAssign.secondLevelInspectors,
                };
            }
        }

        // 准备自动推送数据
        let autoPush = model.autoPush;
        if (autoPush && autoPush instanceof Array && autoPush.length > 0) {
            autoPush.forEach((item) => {
                item._id = Udesk.utils.string.uuid();
                if (item.monitorConf && Array.isArray(item.monitorConf.pushConf)) {
                    item.monitorConf.pushConf.forEach((pushConf) => {
                        if (
                            parseInt(pushConf.actionType, 10) ===
                            Udesk.enums.messagePushType.interfacePush.id
                        ) {
                            pushConf.actionDetails.additionalDataList.forEach((additionalData) => {
                                !additionalData._id &&
                                    (additionalData._id = Udesk.utils.string.uuid());
                            });
                        }
                    });
                    item.monitorConf.pushConf = item.monitorConf.pushConf.filter((item) => {
                        if (item.actionType !== Udesk.enums.messagePushType.udesk.id) {
                            return true;
                        }
                        return Udesk.data.init.middleware === 'udesk';
                    });

                    // 对于触发通知的历史数据，补充新添加的推送方式
                    if (
                        item.monitorConf.messageType === Udesk.enums.messageType.trigger.id &&
                        item.monitorConf.pushConf.length < Udesk.enums.messagePushType.length
                    ) {
                        Udesk.enums.messagePushType.forEach((type) => {
                            if (
                                !item.monitorConf.pushConf.some(
                                    (item) => item.actionType === type.id
                                )
                            ) {
                                item.monitorConf.pushConf.push(
                                    PushConfig({ messagePushType: type.id })
                                );
                            }
                        });
                    }
                }
            });

            this.privates.pushRules = autoPush;
        }

        this.privates.automaticPushConfigList = autoPush;
        // this.privates.pushConfigTab = this.privates.automaticPushConfigList.filter(
        //     (item) =>
        //         item.monitorConf &&
        //         item.monitorConf.messageType === messageType.id
        // )
        // 准备成绩查看配置（findDataResConfig 返回 { code, data: { id, baseFilter, autoMateLoadConf, ... } }，route 中 resolve(resp.data) 故 model.dataResConfig 即为 data）
        let dataResConfig = model.dataResConfig;
        if (dataResConfig && dataResConfig.id != null) {
            this.privates.viewGradeDataResConfigId = dataResConfig.id;
            const isRealtime =
                dataResConfig.isAutoExecute === Udesk.enums.autoAddTypes.realTimeAdd.id;
            const bf = dataResConfig.baseFilter || {};
            const loadConf = dataResConfig.autoMateLoadConf || {};
            // executeTime 统一为 HH:mm，兼容接口返回的 HH:mm:ss
            let executeTime = loadConf.executeTime || '09:00:00';
            if (executeTime.length > 5 && executeTime.indexOf(':') !== -1) {
                executeTime = executeTime.substring(0, 5);
            }
            this.privates.viewGradeConfig = {
                enabled: dataResConfig.taskStatus === 1,
                pushTiming: isRealtime ? 'realtime' : 'scheduled',
                scheduledRules: [
                    {
                        filter: {
                            conditionList: bf.conditionList || [],
                            judgeStrategy: bf.judgeStrategy ?? 1,
                            customJudgeLogic: bf.customJudgeLogic ?? '',
                        },
                        strategy: {
                            loadCycle: loadConf.loadCycle,
                            loadScope: loadConf.loadScope,
                            executeTime: executeTime,
                            dayOfWeek: loadConf.dayOfWeek,
                            dayOfMonth: loadConf.dayOfMonth,
                        },
                    },
                ],
            };
        }
        // 准备自动评估数据
        let { autoAssess } = model;
        this.privates.assessRules = [...autoAssess];

        // 准备抽检配置与复核配置数据
        let autoCheck = model.autoCheck;
        let reviewOptions = [],
            spoktOptions = [],
            spoketOptionsExport = [],
            inspectionOptionsExport = [],
            reviewOptionsExport = [],
            fastSampleInDetailList = [],
            permitCustomReasonList = [],
            callDetailShowConfigList = [],
            overSecondsDurationShow = '';
        if (autoCheck && autoCheck instanceof Array && autoCheck.length > 0) {
            let checkConf = autoCheck[0].checkConf;
            console.log('init:checkConf', checkConf, autoCheck);
            if (checkConf) {
                if (checkConf.checkResult) {
                    reviewOptions.push(1);
                }
                if (checkConf.checkRecord) {
                    reviewOptions.push(2);
                }
                if (checkConf.reviewAgentHidden) {
                    reviewOptions.push(3);
                }

                if (checkConf.sampleResult) {
                    spoktOptions.push(1);
                }
                if (checkConf.sampleRecord) {
                    spoktOptions.push(2);
                }
                if (checkConf.sampleAgentHidden) {
                    spoktOptions.push(3);
                }

                if (checkConf.sampleExportAddCallInfo) {
                    spoketOptionsExport.push(1);
                }

                if (checkConf.inspectionExportAddCallInfo) {
                    inspectionOptionsExport.push(1);
                }

                if (checkConf.checkExportAddCallInfo) {
                    reviewOptionsExport.push(1);
                }

                if (checkConf.fastSampleInInspectDetail) {
                    fastSampleInDetailList.push(1);
                }
                if (checkConf.fastSampleInSampleDetail) {
                    fastSampleInDetailList.push(2);
                }
                if (checkConf.fastSampleInReviewDetail) {
                    fastSampleInDetailList.push(3);
                }

                if (checkConf.permitCustomReason) {
                    permitCustomReasonList.push(1);
                }

                if (checkConf.showSilenceDuration) {
                    callDetailShowConfigList.push('1');
                }

                if (checkConf.overSecondsDurationShow) {
                    overSecondsDurationShow = checkConf.overSecondsDurationShow;
                }

                if (checkConf.playBarShowEmotion) {
                    callDetailShowConfigList.push('2');
                }

                if (checkConf.playBarShowSmartTag) {
                    callDetailShowConfigList.push('3');
                }

                if (checkConf.playBarShowPoint) {
                    callDetailShowConfigList.push('4');
                }

                if (checkConf.permitComplainCount) {
                    this.privates.permitComplainCount = checkConf.permitComplainCount;
                }

                if (checkConf.complainPeriod) {
                    this.privates.complainPeriod = checkConf.complainPeriod;
                }

                this.privates.reviewAging = checkConf.reviewAging;
                this.privates.complainPeriodMode =
                    checkConf.complainPeriodMode || AppealConfigModeMap.Validity;
                this.privates.refreshComplainPeriodAndNum = checkConf.refreshComplainPeriodAndNum;

                this.privates.complainCycle = checkConf.complainCycle;
                this.privates.complainScope = checkConf.complainScope;
                this.privates.complainDeadTime = checkConf.complainDeadTime;
                this.privates.reviewCycle = checkConf.reviewCycle;
                this.privates.reviewScope = checkConf.reviewScope;
                this.privates.reviewDeadTime = checkConf.reviewDeadTime;
                this.privates.complainDeadCount = checkConf.complainDeadCount;
                this.privates.finalReview = checkConf.finalReview;
                this.privates.sdkShowCaseLibrary = checkConf.sdkShowCaseLibrary;
                this.privates.samplePeriodMode =
                    checkConf.samplePeriodMode ?? SamplePeriodModeMap.None;
                this.privates.sampleAging = checkConf.sampleAging;
                this.privates.sampleCycle = checkConf.sampleCycle;
                this.privates.sampleScope = checkConf.sampleScope;
                this.privates.sampleDeadTime = checkConf.sampleDeadTime;

                if (checkConf.exportNumLimit) {
                    this.privates.exportNumLimit = checkConf.exportNumLimit;
                }

                this.privates.appealOptionsExport.complainInspectorHidden =
                    checkConf.complainInspectorHidden || 0;
                this.privates.appealOptionsExport.complainHighLightShow =
                    checkConf.complainHighLightShow || 0;

                this.privates.appaelable.enableComplainAiInspect =
                    checkConf.enableComplainAiInspect || 0;
                this.privates.appaelable.enableComplainManualInspect =
                    checkConf.enableComplainManualInspect || 0;
            }
        }
        this.privates.reviewOptions = reviewOptions;
        this.privates.spoktOptions = spoktOptions;
        this.privates.spoketOptionsExport = spoketOptionsExport;
        this.privates.inspectionOptionsExport = inspectionOptionsExport;
        this.privates.reviewOptionsExport = reviewOptionsExport;
        this.privates.fastSampleInDetailList = fastSampleInDetailList;
        this.privates.permitCustomReasonList = permitCustomReasonList;
        this.privates.callDetailShowConfigList = callDetailShowConfigList;
        this.privates.overSecondsDurationShow = overSecondsDurationShow || 30;

        let taskObj = model.task;
        let spoktOptionsList = [];
        let reviewOptionsList = [];
        let inspectionOptionsList = [];
        if (taskObj && (taskObj.inspectDataSource === 1 || taskObj.inspectDataSource === 3)) {
            spoktOptionsList = Udesk.enums.spoktListResultOptionsExportIphone;
            reviewOptionsList = Udesk.enums.reviewlistResultOptionsExportIphone;
            inspectionOptionsList = Udesk.enums.inspectionListResultOptionsExportIphone.map(
                (i) => ({ ...i, name: i.name.replace('10000', this.privates.exportNumLimit) })
            );
        } else if (
            [
                Udesk.enums.inspectDataSources.textDialogue.id,
                Udesk.enums.inspectDataSources.realTimeTextDialogue.id,
                Udesk.enums.inspectDataSources.taobao.id,
                Udesk.enums.inspectDataSources.eComment.id,
                Udesk.enums.inspectDataSources.mComment.id,
                Udesk.enums.inspectDataSources.survey.id,
            ].includes(taskObj?.inspectDataSource)
        ) {
            spoktOptionsList = Udesk.enums.spoktListResultOptionsExportText;
            reviewOptionsList = Udesk.enums.reviewlistResultOptionsExportText;
            inspectionOptionsList = Udesk.enums.inspectionListResultOptionsExportText.map((i) => ({
                ...i,
                name: i.name.replace('10000', this.privates.exportNumLimit),
            }));
        }
        this.privates.spoktOptionsList = spoktOptionsList;
        this.privates.reviewOptionsList = reviewOptionsList;
        this.privates.inspectionOptionsList = inspectionOptionsList;

        // window.console.log('onModelResolved', 101,this.privates.automaticPushConfigList)
    }
    componentDidMount() {
        const { props } = this;
        let { sdkOptions } = this.props;
        let params = Object.assign(
            {},
            props.match.params,
            Object.fromEntries(new URLSearchParams(props.location.search))
        );
        let statusUrl = Udesk.business.apiPath.concatApiPath(
            `/flowConfigs/taskId/${params.taskId}`,
            sdkOptions
        );
        Udesk.ajax.get(statusUrl).then(
            (resp) => {
                if (resp.data && resp.data.length) {
                    this.privates.everyAgentCheckUpperLimit = {
                        ...this.privates.everyAgentCheckUpperLimit,
                        ...resp.data?.find((d) => d.limitType === LimitType.Upper),
                    };
                    this.privates.everyAgentCheckFloorLimit = {
                        ...this.privates.everyAgentCheckFloorLimit,
                        ...resp.data?.find((d) => d.limitType === LimitType.Floor),
                    };
                    this.actions.update();
                }
            },
            (reason) => {
                Udesk.ui.notify.error(reason.errorMsg);
            }
        );
    }
    //#endregion
}
function getOptionValue(id, optionValueList) {
    let value = optionValueList.filter((item) => {
        if (Array.isArray(id)) {
            return id.includes(item.id);
        } else {
            return item.id === id;
        }
    });
    if (value.length > 0) {
        value = value.map((item) => {
            return item.name;
        });
        return value.join(',');
    } else {
        return '';
    }
}

function getQueryConditionList(allFieldList, conditionList) {
    let queryConditionList = [];
    if (conditionList && conditionList instanceof Array && conditionList.length > 0) {
        queryConditionList = Udesk.utils.object.deepCopy(conditionList);
        if (queryConditionList && queryConditionList.length > 0) {
            queryConditionList.map((condition) => {
                allFieldList.forEach((field) => {
                    if (condition.field === field.id) {
                        condition.field = field;
                    }
                });
                return condition;
            });
        }
    }
    return queryConditionList;
}

function createAutomaticPushConfig(messageType, taskId) {
    let config = AutomaticPushConfig({ messageType });
    config._id = Udesk.utils.string.uuid();
    config.taskId = taskId * 1;
    config.taskType = 8;
    return config;
}

export function AutomaticPushConfig({
    messageType = Udesk.enums.messageType.trigger.id,
    interfacePushType,
}) {
    let config = {
        baseFilter: {
            conditionList: [],
            judgeStrategy: 1,
            customJudgeLogic: '',
        },
        monitorConf: {
            messageType: messageType,
            pushConf: [],
            pushCycle: 1,
            daysOfWeek: [],
            daysOfMonth: [],
            pushDataTypes: [], //传空list
            name: '',
        },
    };
    if (messageType === Udesk.enums.messageType.timing.id) {
        config.monitorConf.pushConf.push(
            PushConfig({ messagePushType: Udesk.enums.messagePushType.email.id, interfacePushType })
        );
    } else {
        Udesk.enums.messagePushType
            .filter((item) => {
                if (item.id !== Udesk.enums.messagePushType.udesk.id) {
                    return true;
                }
                return Udesk.data.init.middleware === 'udesk';
            })
            .forEach((messagePushType) => {
                if (messagePushType.id) {
                    config.monitorConf &&
                        Array.isArray(config.monitorConf.pushConf) &&
                        config.monitorConf.pushConf.push(
                            PushConfig({ messagePushType: messagePushType.id, interfacePushType })
                        );
                }
            });
    }

    return config;
}

export function PushConfig({
    messagePushType,
    interfacePushType = Udesk.enums.sdkPushType.webHook.id,
} = {}) {
    let config = {
        pushCycle: 1,
        eventSources: [],
        executeTime: '',
        email: '',
        actionDetails: {
            actionType: messagePushType,
            pushTargetList: [],
            pushUserList: [],
            pushRoleList: [],
            content: '',
        },
        pushType: 1,
        actionType: messagePushType,
        enabled: 0, //是否生效 被选中
    };
    let extra = {};
    //接口推送有附加字段
    if (messagePushType === Udesk.enums.messagePushType.interfacePush.id) {
        // no-locale-translate
        extra = {
            additionalDataList: [
                {
                    _id: Udesk.utils.string.uuid(),
                    key: '',
                    value: '',
                },
            ],
            type: interfacePushType,
            contentType: 'json',
            pushDataTypes: [1, 2, 3, 4],
            requestMethod: 'post',
            url: '',
            content:
                '{\n  "msgtype": "text",\n  "text": {\n    "content": "我就是我, 是不一样的烟火@156xxxx8827"\n  },\n  "at": {\n    "atMobiles": [\n      "156xxxx8827",\n      "189xxxx8325"\n    ],\n    "isAtAll": false\n  }\n}',
        };
    }
    if (messagePushType === Udesk.enums.messagePushType.email.id) {
        extra = {
            pushTargetType: Udesk.enums.pushObjectTypes.staff.id,
            subject: '',
            targetEmails: '',
        };
    }
    if (messagePushType === Udesk.enums.messagePushType.udesk.id) {
        extra = {
            pushTargetType: Udesk.enums.pushObjectTypes.staff.id,
            targetEmails: '',
        };
    }
    if (messagePushType === Udesk.enums.messagePushType.sdk.id) {
        extra = {
            SDK: '',
        };
    }
    if (messagePushType === Udesk.enums.messagePushType.ticket.id) {
        extra = {
            agentType: AgentTyoeMap.Belong,
            agentEmail: '',
            title: '',
        };
    }

    config.actionDetails = { ...config.actionDetails, ...extra };

    return config;
}
